// extracted by mini-css-extract-plugin
export default {"productParamtersC":"index_productParamtersC__xPBJH","content":"index_content__cpKuE","name":"index_name__spUHb","desc":"index_desc__dm-GM","line":"index_line__WgfgM"};